// extracted by mini-css-extract-plugin
module.exports = {"results":"Results-module__results___2-4WH","result":"Results-module__result___1xnt4 Fonts-module__h4___38fDC"};